import { NgModule } from '@angular/core';

import { NoSpacesDirective } from './no-spaces.directive';

@NgModule({
  exports: [NoSpacesDirective],
  declarations: [NoSpacesDirective],
})
export class NoSpacesModule {
}
